import { request } from './fetch';

// 付款方式
export const getPayTypeList = config => request('get', '/business/payType/list/v2', config) //付款方式列表
export const syncPayType = config => request('put', '/business/payType/sync/pay/type', config) // 同步付款方式
export const updateReportSale = config => request('put', '/business/payType/update/report/sale', config) // 修改上报销售付款方式